import { Divider, Grid } from '@material-ui/core';
import React from 'react';
import Circle from './Circle';

export interface HeaderProps {
  share: number;
  label: string;
  progressColor: string;
  backgroundColor: string;
  labelColor: string;
}

export const Header: React.FC<HeaderProps> = ({
  label,
  share,
  progressColor,
  backgroundColor,
  labelColor,
}) => {
  return (
    <>
      <Grid item>
        <Circle
          share={share}
          progressColor={progressColor}
          backgroundColor={backgroundColor}
          labelColor={labelColor}
        />
      </Grid>
      <Grid item>
        <div className="font-normal text-[22px] text-center text-ellipsis overflow-hidden">
          {label}
        </div>
        <div className="my-2">
          <Divider />
        </div>
      </Grid>
    </>
  );
};

export default Header;
